var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditWearDays(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.8801 2.71777H24.4839L25.567 1.63464C25.9413 1.26033 25.9413 0.655052 25.567 0.280737C25.1927 -0.0935789 24.5874 -0.0935789 24.2131 0.280737L21.5053 2.99652C21.3221 3.17969 21.2266 3.41862 21.2266 3.67347C21.2266 3.92832 21.3301 4.16725 21.5053 4.35042L24.2211 7.0662C24.4043 7.24938 24.6512 7.34495 24.898 7.34495C25.1449 7.34495 25.3839 7.24938 25.575 7.0662C25.9493 6.69189 25.9493 6.08661 25.575 5.7123L24.4919 4.62917H28.8881C31.7472 4.62917 34.0648 6.9547 34.0648 9.80587V13.0154C34.0648 13.5411 34.4949 13.9711 35.0205 13.9711C35.5461 13.9711 35.9762 13.5411 35.9762 13.0154V9.80587C35.9762 5.89547 32.7905 2.71777 28.8801 2.71777Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.9499 18.3906H19.2526C18.7269 18.3906 18.2969 18.8207 18.2969 19.3463V35.0437C18.2969 35.5693 18.7269 35.9994 19.2526 35.9994H34.9499C35.4756 35.9994 35.9056 35.5693 35.9056 35.0437V19.3463C35.9056 18.8127 35.4756 18.3906 34.9499 18.3906ZM33.9942 34.088H20.2083V20.302H33.9942V34.088Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.7785 28.9362C11.4042 28.5619 10.7989 28.5619 10.4246 28.9362C10.0503 29.3105 10.0503 29.9158 10.4246 30.2901L11.5078 31.3732H7.11154C4.25241 31.3732 1.93484 29.0477 1.93484 26.1965V22.9869C1.93484 22.4613 1.50477 22.0312 0.979137 22.0312C0.453502 22.0312 0.0234375 22.4613 0.0234375 22.9869V26.1965C0.0234375 30.1069 3.20114 33.2846 7.11154 33.2846H11.5078L10.4246 34.3677C10.0503 34.7421 10.0503 35.3473 10.4246 35.7216C10.6078 35.9048 10.8547 36.0004 11.1016 36.0004C11.3485 36.0004 11.5874 35.9048 11.7785 35.7216L14.4943 33.0059C14.8686 32.6315 14.8686 32.0263 14.4943 31.652L11.7785 28.9362Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.04945 1.91531C1.3043 1.91531 1.55119 1.81177 1.7264 1.63656C1.90161 1.46135 2.00515 1.21446 2.00515 0.959606C2.00515 0.712717 1.90161 0.457863 1.7264 0.282652C1.55119 0.10744 1.3043 0.00390625 1.04945 0.00390625C0.794596 0.00390625 0.547707 0.10744 0.372496 0.282652C0.197284 0.457863 0.09375 0.704753 0.09375 0.959606C0.09375 1.21446 0.197284 1.46135 0.372496 1.63656C0.555671 1.81177 0.794596 1.91531 1.04945 1.91531Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.90101 1.91531C9.42665 1.91531 9.85671 1.48524 9.85671 0.959606C9.85671 0.433971 9.42665 0.00390625 8.90101 0.00390625C8.37538 0.00390625 7.94531 0.433971 7.94531 0.959606C7.94531 1.48524 8.36741 1.91531 8.90101 1.91531Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.97914 1.91531C5.50477 1.91531 5.93484 1.48524 5.93484 0.959606C5.93484 0.433971 5.50477 0.00390625 4.97914 0.00390625C4.4535 0.00390625 4.02344 0.433971 4.02344 0.959606C4.02344 1.48524 4.4535 1.91531 4.97914 1.91531Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.8229 1.91531C13.3485 1.91531 13.7786 1.48524 13.7786 0.959606C13.7786 0.433971 13.3485 0.00390625 12.8229 0.00390625C12.2973 0.00390625 11.8672 0.433971 11.8672 0.959606C11.8672 1.48524 12.2973 1.91531 12.8229 1.91531Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.7448 0.00390625C16.4979 0.00390625 16.243 0.10744 16.0678 0.282652C15.8926 0.457863 15.7891 0.704753 15.7891 0.959606C15.7891 1.21446 15.8926 1.46135 16.0678 1.63656C16.243 1.81177 16.4899 1.91531 16.7448 1.91531C16.9996 1.91531 17.2465 1.81177 17.4217 1.63656C17.5969 1.46135 17.7005 1.21446 17.7005 0.959606C17.7005 0.704753 17.5969 0.457863 17.4217 0.282652C17.2465 0.10744 16.9996 0.00390625 16.7448 0.00390625Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M16.7448 11.7812C16.2191 11.7812 15.7891 12.2113 15.7891 12.7369C15.7891 13.2626 16.2191 13.6926 16.7448 13.6926C17.2704 13.6926 17.7005 13.2626 17.7005 12.7369C17.7005 12.2034 17.2784 11.7812 16.7448 11.7812Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M16.7448 7.85547C16.2191 7.85547 15.7891 8.28553 15.7891 8.81117C15.7891 9.3368 16.2191 9.76687 16.7448 9.76687C17.2704 9.76687 17.7005 9.3368 17.7005 8.81117C17.7005 8.27757 17.2784 7.85547 16.7448 7.85547Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M16.7448 3.92969C16.2191 3.92969 15.7891 4.35975 15.7891 4.88539C15.7891 5.41102 16.2191 5.84109 16.7448 5.84109C17.2704 5.84109 17.7005 5.41102 17.7005 4.88539C17.7005 4.35975 17.2784 3.92969 16.7448 3.92969Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M16.7448 15.6992C16.4899 15.6992 16.243 15.8028 16.0678 15.978C15.8926 16.1532 15.7891 16.4001 15.7891 16.6549C15.7891 16.9018 15.8926 17.1567 16.0678 17.3319C16.243 17.5071 16.4899 17.6106 16.7448 17.6106C16.9996 17.6106 17.2465 17.5071 17.4217 17.3319C17.5969 17.1567 17.7005 16.9098 17.7005 16.6549C17.7005 16.4001 17.5969 16.1532 17.4217 15.978C17.2466 15.8028 16.9996 15.6992 16.7448 15.6992Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M12.8229 17.6106C13.3485 17.6106 13.7786 17.1806 13.7786 16.6549C13.7786 16.1293 13.3485 15.6992 12.8229 15.6992C12.2973 15.6992 11.8672 16.1293 11.8672 16.6549C11.8672 17.1885 12.2973 17.6106 12.8229 17.6106Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M8.90101 17.6106C9.42665 17.6106 9.85671 17.1806 9.85671 16.6549C9.85671 16.1293 9.42665 15.6992 8.90101 15.6992C8.37538 15.6992 7.94531 16.1293 7.94531 16.6549C7.94531 17.1885 8.36741 17.6106 8.90101 17.6106Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M4.97914 17.6106C5.50477 17.6106 5.93484 17.1806 5.93484 16.6549C5.93484 16.1293 5.50477 15.6992 4.97914 15.6992C4.4535 15.6992 4.02344 16.1293 4.02344 16.6549C4.02344 17.1885 4.4535 17.6106 4.97914 17.6106Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M1.04945 17.6106C1.3043 17.6106 1.55119 17.5071 1.7264 17.3319C1.90161 17.1567 2.00515 16.9098 2.00515 16.6549C2.00515 16.4001 1.90161 16.1532 1.7264 15.978C1.55119 15.8028 1.3043 15.6992 1.04945 15.6992C0.794596 15.6992 0.547707 15.8028 0.372496 15.978C0.197284 16.1532 0.09375 16.4001 0.09375 16.6549C0.09375 16.9018 0.197284 17.1567 0.372496 17.3319C0.555671 17.5071 0.794596 17.6106 1.04945 17.6106Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M1.04945 13.6926C1.57508 13.6926 2.00515 13.2626 2.00515 12.7369C2.00515 12.2113 1.57508 11.7812 1.04945 11.7812C0.523815 11.7812 0.09375 12.2113 0.09375 12.7369C0.09375 13.2626 0.523815 13.6926 1.04945 13.6926Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M1.04945 9.76687C1.57508 9.76687 2.00515 9.3368 2.00515 8.81117C2.00515 8.28553 1.57508 7.85547 1.04945 7.85547C0.523815 7.85547 0.09375 8.28553 0.09375 8.81117C0.09375 9.3368 0.523815 9.76687 1.04945 9.76687Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M1.04945 5.84109C1.57508 5.84109 2.00515 5.41102 2.00515 4.88539C2.00515 4.35975 1.57508 3.92969 1.04945 3.92969C0.523815 3.92969 0.09375 4.35975 0.09375 4.88539C0.09375 5.41102 0.523815 5.84109 1.04945 5.84109Z",
    fill: "#735BF2",
    stroke: "#735BF2",
    strokeWidth: 0.00064
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWearDays);
export default __webpack_public_path__ + "static/media/editWearDays.065789f1cef689bcb9e0ccb4fbd5e60b.svg";
export { ForwardRef as ReactComponent };